import { render, staticRenderFns } from "./picture-message.vue?vue&type=template&id=2d229867&scoped=true&"
import script from "./picture-message.vue?vue&type=script&lang=js&"
export * from "./picture-message.vue?vue&type=script&lang=js&"
import style0 from "./picture-message.vue?vue&type=style&index=0&id=2d229867&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d229867",
  null
  
)

export default component.exports